import AppCard from "@lib/components/AppComponents/AppCard";
import { Breadcrumb, Button, Card, Drawer } from "antd";
import styled, { css } from "styled-components";

export const StyledAppContentContainer = styled.div`
  position: relative;
  display: flex;
  border-bottom-left-radius: ${({ theme }) => theme.cardRadius};
  border-bottom-right-radius: ${({ theme }) => theme.cardRadius};
  overflow: hidden !important;

  &.fullView {
    height: 100% !important;
  }
`;

export const StyledAppFooter = styled.div`
  padding: 8px 24px;
  border-top: 1px solid ${({ theme }) => theme.palette.borderColor};
`;

export const StyledAppsHeader = styled.div<{
  mobile?: boolean;
  bg?: "primary" | "secondary";
}>`
  padding: ${({ mobile }) => (mobile ? "5px" : "5px 24px")};
  height: auto;
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.palette.borderColor};
  background-color: ${({ theme, bg }) =>
    bg === "secondary"
      ? theme.palette.background.secondary
      : theme.palette.background.paper};
  border-top-left-radius: ${({ theme }) => theme.cardRadius};
  border-top-right-radius: ${({ theme }) => theme.cardRadius};
  // border: 1px dashed ${({ theme }) => theme.palette.borderColor};
  // box-shadow: ${({ theme }) => theme.cardShadow};

  > div {
    .ant-radio-group {
      background: transparent !important;
    }
  }
`;

export const StyledAppSidebar = styled.div<{ collapsed: boolean }>`
  position: relative;
  height: fit-content;
  display: none;
  flex-direction: column;
  border: 1px solid ${({ theme }) => theme.palette.background.paper};
  border: transparent;
  transition: all 0.5s ease;
  overflow: visible !important;
  max-width: ${({ collapsed }) => (collapsed ? "100px" : "320px")};
  width: 100%;
  min-width: 0;
  transition: all 0.5s ease;
  box-shadow: none !important;

  .sidebar-collapse-btn {
    display: none;
  }

  &:hover .sidebar-collapse-btn {
    display: flex;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}px) {
    display: flex;
  }
`;

export const StyledAppSidebarDrawer = styled(Drawer)`
  & .ant-drawer-content-wrapper {
    width: 17.5rem !important;
  }

  & .ant-drawer-body {
    padding: 0;
  }
`;

export const StyledBreadcrumb = styled(Breadcrumb)`
  margin: 5px 0;
  ol {
    display: flex;
    align-items: center !important;
    justify-content: flex-start !important;
    gap: 5px;

    .ant-breadcrumb-link {
      cursor: pointer;
    }
  }
`;

export const StyledAppSidebarCard = styled(Card)`
  display: none;
  height: fit-content;
  border: 0;
  position: relative;
  overflow: hidden !important;
  transition: all 0.3s ease;
  box-shadow: none !important;

  & > .ant-card-body {
    padding: 0;
    height: inherit;
    overflow: auto !important;
    padding: 10 !important;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    flex: 1;
    display: block;
    flex-direction: column;
  }
`;

export const StyledAppWrap = styled.div<{
  noPadding?: boolean;
  height?: number;
}>`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: ${({ noPadding }) => (noPadding ? "0" : "10px")};
  overflow: visible !important;
  ${({ height }) =>
    height &&
    css`
      height: ${height}px;
      overflow: hidden;
    `}
`;

export const StyledAppWrapHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}px) {
    display: none;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xxl}px) {
    margin-bottom: 20px;
  }

  & h2 {
    color: ${({ theme }) => theme.palette.text.primary};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    font-size: ${({ theme }) => theme.font.size.lg};
    margin-bottom: 0;
  }
`;

export const StyledMenuBtn = styled(Button)`
  display: block;
  margin-right: 8px;
  padding: 0;
  background-color: transparent;
  box-shadow: none;
  border: 0 none;
  width: 35px;
  height: 35px;
  color: ${({ theme }) => theme.palette.text.primary};

  [dir="rtl"] & {
    margin-right: 0;
    margin-left: 8px;
  }

  &:hover,
  &:focus {
    background-color: transparent;
    color: ${({ theme }) => theme.palette.text.primary};
  }

  & .anticon {
    font-size: 20px;
  }
`;

export const StyledAppContainer = styled.div<{ height?: number }>`
  display: flex;
  gap: 20px;
  flex-direction: row;
  flex: 1;
  height: auto;
  transition: all 0.5s ease;
  position: relative;

  ${({ height }) =>
    height &&
    css`
      height: ${height}px;
      overflow: hidden;
    `}
`;

export const StyledSidebarCard = styled(Card)`
  width: 100%;
  overflow: visible !important;
  position: relative;

  & > .ant-card-body {
    flex: 1;
    padding: 0;
    display: flex;
    flex-direction: column;
    height: inherit;
  }
`;

export const StyledMainContentCard = styled(AppCard)<{ bg?: boolean }>`
  display: flex;
  flex-direction: column;
  height: fit-content;
  width: 100%;
  border-radius: ${({ theme }) => theme.cardRadius};
  background-color: ${({ bg, theme }) =>
    !bg ? "transparent" : theme.palette.background.paper} !important;
  padding: ${({ bg }) => (!bg ? "0" : "20px")};
  box-sizing: border-box !important;

  & > .ant-card-body {
    padding: 0;
    display: flex;
    flex-direction: column;
    height: inherit;
  }
`;
